module.exports = __webpack_public_path__ + "static/media/pakhi.463acbb6.jpg";